// core-js replaces JSON on engines without native Symbol with ~100x slower pure-JS versions.

export interface NativeJson {
  parse: JSON["parse"];
  stringify: JSON["stringify"];
}

declare global {
  interface Window {
    __POS_NATIVE_JSON__?: NativeJson;
  }
}

export function restoreNativeJson(target: JSON, saved: NativeJson | undefined): boolean {
  if (!saved) return false;
  if (target.parse === saved.parse && target.stringify === saved.stringify) return false;
  target.parse = saved.parse;
  target.stringify = saved.stringify;
  // Only the polyfilled stringify understands these.
  const extras = target as unknown as Record<string, unknown>;
  delete extras.rawJSON;
  delete extras.isRawJSON;
  return true;
}
